import { loggedIn, loggedInAndNotProlidUser } from '../middleware/middleware';

import Signin from '../../components/auth/Signin';
// import Login from '../../components/auth/Login';
import Signup from '../../components/auth/Signup';
import EditAccount from '../../components/auth/EditAccount';
import EditAccountPassword from '../../components/auth/EditAccountPassword';
import ResetPassword from '../../components/auth/ResetPassword';
import VerifyEmail from '../../components/auth/VerifyEmail';

export default [
  { path: '/signin', component: Signin, meta: { allowFirstRoute: true, useSignInForNavbar: true } },

  { path: '/signin/link/:registrationLink', component: Signin, props: true, meta: { allowFirstRoute: true, useSignInForNavbar: true } },
  { path: '/signup/link/:registrationLink', component: Signup, props: true, meta: { allowFirstRoute: true, forceFirstRoute: true, useSignInForNavbar: true } },
  { path: '/signin/class/:classId', component: Signin, props: true, meta: { allowFirstRoute: true, useSignInForNavbar: true } },
  { path: '/signup/class/:classId', component: Signup, props: true, meta: { allowFirstRoute: true, useSignInForNavbar: true } },

  { path: '/signin/:code', component: Signin, props: route => ({ code: route.params.code, role: 'client' }), meta: { allowFirstRoute: true, useSignInForNavbar: true } },
  { path: '/signup/:code', component: Signup, props: route => ({ code: route.params.code, role: 'client' }), meta: { allowFirstRoute: true, useSignInForNavbar: true } },
  { path: '/signin/:role/:classId', component: Signin, props: route => ({ classId: route.params.classId, role: route.params.role }), meta: { allowFirstRoute: true, useSignInForNavbar: true } },
  { path: '/signup/:role/:classId', component: Signup, props: route => ({ classId: route.params.classId, role: route.params.role }), meta: { allowFirstRoute: true, useSignInForNavbar: true } },
  // { path: '/login', component: Login },
  // { path: '/signup', component: Signup, meta: { useSignInForNavbar: true } },
  { path: '/user/edit', component: EditAccount, beforeEnter: loggedInAndNotProlidUser },
  { path: '/user/password', component: EditAccountPassword, beforeEnter: loggedIn },
  { path: '/resetpassword/:code', component: ResetPassword, meta: { allowFirstRoute: true, useSignInForNavbar: true } },
  { path: '/verifyemail/:code', component: VerifyEmail, meta: { allowFirstRoute: true, useSignInForNavbar: true } }
];



// WEBPACK FOOTER //
// ./src/router/auth/routes.js